import { countBy, range, uniqBy } from "lodash";
import { BookingCalendar, ProfileCalendar } from "PFApp/booking/types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import bookingCalendarCss from "../../../booking_calendars.module.scss";
import css from "../workforce.module.scss";

type CalendarNameCellProps = {
  startDates: ProfileCalendar[];
  calendars: BookingCalendar[];
};

export const CalendarNameCell = ({ startDates, calendars }: CalendarNameCellProps) => {
  const calendarsIdCounter = countBy(startDates, (date) => date.calendar_id);

  return (
    <div className={bookingCalendarCss.calendarsGridCell}>
      {uniqBy(startDates, "calendar_id").map(({ id, calendar_id: calendarId }) => (
        <Fragment key={id}>
          <Link className={css.cellEntry} to={`/admin/booking/calendars/${calendarId}`}>
            {calendars.find(({ id }) => id === calendarId)?.name}
          </Link>
          {range(calendarsIdCounter[calendarId] - 1).map((index) => (
            <div key={`${calendarsIdCounter[calendarId]}-${index}`} className={css.cellEntry} />
          ))}
        </Fragment>
      ))}
    </div>
  );
};
